import type { ComputedRef, MaybeRefOrGetter } from 'vue';

import { usePreferredReducedMotion } from '@vueuse/core';
import { computed, toValue } from 'vue';

const SLIDE_UP = { initial: { opacity: 0, y: 40 }, animate: { y: 0, opacity: 1 } };
const TRANSITION = { duration: 0.35, ease: 'easeOut' as const };

export const useMotionPresets = () => {
  const staggeredTransition = (index: number, baseDelay = 0, increment = 0.08) => ({
    ...TRANSITION,
    delay: baseDelay + index * increment,
  });

  return { SLIDE_UP, TRANSITION, staggeredTransition };
};

/** Whether something may move: the app's own animations switch, and the OS not asking for reduced motion. */
export const useMotionAllowed = (animated?: MaybeRefOrGetter<boolean>): ComputedRef<boolean> => {
  const reducedMotion = usePreferredReducedMotion();

  return computed(() => toValue(animated ?? true) && reducedMotion.value !== 'reduce');
};
